module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"New Celus version available","text":"Celus is being updated ({oldVersion} -> {newCelusVersion}).","wait":"Wait a moment, please...","button":"Update now"},"cs":{"title":"Je dostupná nová verze Celusu","text":"Celus se aktualizuje ({oldVersion} -> {newCelusVersion}).","wait":"Mějte prosím chvilku strpení...","button":"Aktualizovat hned"}}')
  delete Component.options._Ctor
}
